export default {
    "SETTINGS": {
        "target": "Cél dátum",
        "ad_url": "Középső csempe cél",
        "contact_email": "Form email cím",
        "main_page_text": "Fő oldal szöveg HU",
        "main_page_text_hu": "Fő oldal szöveg HU",
        "main_page_text_en": "Fő oldal szöveg EN",
        "main_page_image": "Fő oldal háttérkép",
        "form_fazekas": "Űrlap: Fazekastalálkozó",
        "form_vendeglatos": "Űrlap: Vendéglátósok",
        "form_maganudvar": "Űrlap: Magánudvar",
        "form_malomudvar": "Űrlap: Malomsziget",
        "form_kastelyudvar": "Űrlap: Malomsziget",
        "form_zenekar": "Űrlap: Fellépők",
        'form_egyeb': 'Űrlap: Egyéb',
        "gallery_intro_en": "Galléria intró EN",
        "gallery_intro_hu": "Galléria intró HU",
        "main_page_programs_link": "Program szekció link",
        "main_page_link": "Fő kép Link",
        "main_page_logo": "Logo HU",
        "main_page_logo_hu": "Logo HU",
        "main_page_logo_en": "Logo EN",
        "main_page_counter_en": "Fő oldal visszaszámláló szöveg EN",
        "main_page_counter_hu": "Fő oldal visszaszámláló szöveg HU",
        "main_page_categories_header_hu": "Fő oldal kategóriák cím HU",
        "main_page_categories_header_en": "Fő oldal kategóriák cím EN",
        "app_url_android": "App Url Android",
        "app_url_ios": "App Url iOS",
        'main_page_youtube_embed': 'Aftermovie',
        'main_page_galleries_header_hu': 'Galléria cím HU',
        'main_page_galleries_header_en': 'Galléria cím EN',
        'main_page_tickets_header_hu': 'Jegyek cím HU',
        'main_page_tickets_header_en': 'Jegyek cím EN',
        'page_title_hu': 'Oldal cím HU',
        'page_title_en': 'Oldal cím EN',
        'page_description_hu': 'Oldal leírás HU',
        'page_description_en': 'Oldal leírás EN',
        'date_from': 'Kezdődátum',
        'date_to': 'Végedátum',
        'social_instagram': 'Instagram link',
        'social_facebook': 'Facebook link',
        'social_youtube': 'Youtube link',
        'social_spotify': 'Spotify link',
        'webshop_title_hu': 'Webshop cím HU',
        'webshop_title_en': 'Webshop cím EN',
        'webshop_description_hu': 'Webshop leírás HU',
        'webshop_description_en': 'Webshop leírás EN',
        'webshop_link_text_hu': 'Webshop Link Szöveg HU',
        'webshop_link_text_en': 'Webshop Link Szöveg EN',
        'webshop_link': 'Webshop Link',
        'main_page_ticket_button_hu': 'Jegyvásárlás gomb szöveg HU',
        'main_page_ticket_button_en': 'Jegyvásárlás gomb szöveg EN',
        'main_page_programs_button_hu': 'Programok gomb szöveg HU',
        'main_page_programs_button_en': 'Programok gomb szöveg EN',
        'webshop_image': 'Webshop kép',
        'egesz-napos-programok-image': 'Egész napos programok mobil kép',
        'most-szinpadon-image': 'Mosz színpadon mobil kép',
        'footer_follow_hu': 'Footer kövess minket HU',
        'footer_follow_en': 'Footer kövess minket EN',
        'page_subdescription_hu': 'Oldal alcím HU',
        'page_subdescription_en': 'Oldal alcím EN',

        // Fő oldal 2027 tartalmak
        'main_page_eyebrow_hu': 'Fő cím felirat (eyebrow) HU',
        'main_page_eyebrow_en': 'Fő cím felirat (eyebrow) EN',
        'main_page_featured_artists_eyebrow_hu': 'Fellépők szekció felirat HU',
        'main_page_featured_artists_eyebrow_en': 'Fellépők szekció felirat EN',
        'main_page_featured_artists_title_hu': 'Fellépők szekció cím HU',
        'main_page_featured_artists_title_en': 'Fellépők szekció cím EN',
        'main_page_program_categories_title_hu': 'Program kategóriák cím HU',
        'main_page_program_categories_title_en': 'Program kategóriák cím EN',
        'main_page_video_eyebrow_hu': 'Videó szekció felirat HU',
        'main_page_video_eyebrow_en': 'Videó szekció felirat EN',
        'main_page_video_title_hu': 'Videó szekció cím HU',
        'main_page_video_title_en': 'Videó szekció cím EN',
        'main_page_video_text_hu': 'Videó szekció szöveg HU',
        'main_page_video_text_en': 'Videó szekció szöveg EN',
        'main_page_gallery_title_hu': 'Galéria szekció cím HU',
        'main_page_gallery_title_en': 'Galéria szekció cím EN',
        'main_page_description_eyebrow_hu': 'Leírás szekció felirat HU',
        'main_page_description_eyebrow_en': 'Leírás szekció felirat EN',
        'main_page_description_title_hu': 'Leírás szekció cím HU',
        'main_page_description_title_en': 'Leírás szekció cím EN',
        'main_page_description_text_hu': 'Leírás szekció szöveg HU',
        'main_page_description_text_en': 'Leírás szekció szöveg EN',
        'main_page_description_content_hu': 'Leírás szekció tartalom (cím + szöveg) HU',
        'main_page_description_content_en': 'Leírás szekció tartalom (cím + szöveg) EN',
        'main_page_webshop_title_hu': 'Webshop szekció cím HU',
        'main_page_webshop_title_en': 'Webshop szekció cím EN',
        'main_page_webshop_text_hu': 'Webshop szekció szöveg HU',
        'main_page_webshop_text_en': 'Webshop szekció szöveg EN',
        'main_page_subscription_title_hu': 'Feliratkozás szekció cím HU',
        'main_page_subscription_title_en': 'Feliratkozás szekció cím EN',
        'main_page_subscription_text_hu': 'Feliratkozás szekció szöveg HU',
        'main_page_subscription_text_en': 'Feliratkozás szekció szöveg EN',
        'main_page_news_title_hu': 'Hírek szekció cím HU',
        'main_page_news_title_en': 'Hírek szekció cím EN',
        'main_page_faq_title_hu': 'GYIK szekció cím HU',
        'main_page_faq_title_en': 'GYIK szekció cím EN',
        'main_page_map_title_hu': 'Térkép szekció cím HU',
        'main_page_map_title_en': 'Térkép szekció cím EN',

        'main_page_shop_images_en': 'Webshop szekció képek EN',
        'main_page_shop_images_hu': 'Webshop szekció képek HU',

        // Webshop felirat (Beállítások)
        'webshop_eyebrow_hu': 'Webshop felirat (eyebrow) HU',
        'webshop_eyebrow_en': 'Webshop felirat (eyebrow) EN',
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/hu/settings.js